/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DCTemplar() {
  const data = [
    {
      icon: "alt_route",
      title: "Flexibilidade de Implementação",
      items: ["Já em uso em dezenas de diferentes indústrias", "Uso central e em Edge computing"],
    },
    {
      icon: "support_agent",
      title: "Suporte 24h",
      items: ["Suporte especializado em Português e Inglês", "Rápida resolução de graves incidentes"],
    },
    {
      icon: "shield",
      title: "Segurança customizada",
      items: ["Falsificação de IP baseada em zona", "Padrões triplos de criptografia de dados (3DES) 168 bit"],
    },
    {
      icon: "bolt",
      title: "Rápido Estabelecimento de Redes Seguras",
      items: ["Possibilidade de expansão da rede segura em questão de minutos", "Isolamento veloz de ataques e proteção dos dados"],
    },
    {
      icon: "receipt_long",
      title: "Segurança em Conciliação e Relatórios Financeiros",
      items: ["Conformidade com LGPD, Basel III e AML", "Relatórios em tempo real"],
    },
    {
      icon: "hub",
      title: "Ampla conectividade",
      items: ["Wi-Fi, 4/5G LTE, Satélite/VSAT e Dual SIM", "Roteador craddlepoint embutido"],
    },
  ];

  return (
    <MKBox component="section" py={12} px={1}>
      <Container>
        <Grid container item xs={12} lg={8}>
          <MKTypography variant="h3">Recursos inigualáveis</MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="text">
            O Templar é uma plataforma de comunicação e data center móvel robusta e ecológica em uma caixa pelicano. Permitindo de forma exclusiva 
            uma unidade de comunicação potente e portátil, essa tecnologia de ponta foi projetada para dar suporte à rápida implantação de 
            infraestrutura essencial em áreas remotas em questão de minutos.
          </MKTypography>
        </Grid>
        <Grid container sx={{ mt: 6 }}>
          {data.map(({ icon, title, items }) => (
            <Grid key={icon} item xs={12} md={4}>
              <MKBox py={2} pr={2}>
                <MKTypography variant="h3" color="info">
                  <Icon>{icon}</Icon>
                </MKTypography>
                <MKTypography variant="h5" mt={2} mb={3}>
                  {title}
                </MKTypography>
                {items.map((item) => (
                  <MKBox key={item} display="flex" lineHeight={1.25}>
                    <MKTypography variant="body1" color="info">
                      <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                    </MKTypography>
                    <MKBox pl={2}>
                      <MKTypography variant="button" color="text" fontWeight="bold">
                        {item}
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default DCTemplar;
